import { useCreateDocument, useDocumentNames } from "@api/documents";
import i18n from "@i18n/i18n";
import { Button, Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useState } from "react";
import DocumentsGrid from "../DocumentsPage/DocumentsGrid";

const DocumentPage = observer(() => {
  const allowedExtensions = ["pdf", "ppt", "doc", "docx", "pptx", "xlsx", "xlsm"];
  const maxFileSize = 20 * 1024 * 1024;
  const [validationMessage, setValidationMessage] = useState("");
  const uploadFile = useCreateDocument();
  const allDocumentNames = useDocumentNames();

  const handleFileChange = async (event: any) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    const validationError = validateFile(selectedFile);
    if (validationError) {
      setValidationMessage(validationError);

      setTimeout(() => {
        setValidationMessage("");
      }, 9000);
      console.info("event", event.target.value);
      event.target.value = "";
      return;
    } else {
      setValidationMessage("");
    }

    try {
      const fileParam: any = {
        data: selectedFile,
        fileName: selectedFile.name,
      };

      await uploadFile.mutateAsync(fileParam);
    } catch (error) {
      console.error("Upload Error:", error);
    } finally {
      allDocumentNames.refetch();
    }
    event.target.value = "";
  };

  const validateFile = (file: File) => {
    const fileExtension = file.name.split(".").pop()?.toLowerCase() || "";
    if (file.size > maxFileSize) {
      return i18n.t("document-tab.file-size");
    }

    if (!allowedExtensions.includes(fileExtension)) {
      return i18n.t("document-tab.file-type");
    }

    return null;
  };

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("document-tab.document")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Button variant="contained" component="label">
            {i18n.t("document-tab.upload-button")}
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
          {validationMessage && <div style={{ color: "red", marginTop: "7px", marginLeft: "5px" }}>{validationMessage}</div>}
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <DocumentsGrid />
        </Grid>
      </Grid>
    </Container>
  );
});

export default DocumentPage;
